
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { nselect, dicSelect, customModal, textEditor, uploadFile, javaUploadFile, comRegion, jsonEdit } from "@newview/ui";
import dicText from "./dicText.vue";
import XEUtils, { isNull, keys } from 'xe-utils'
import vxeGridCellExpand from "./vxeGridCellExpand"
@Component({
    name: "vxeGridCell",
    components: {
        nselect,
        dicSelect,
        dicText,
        customModal,
        textEditor,
        uploadFile,
        javaUploadFile,
        comRegion,
        jsonEdit,
        vxeGridCellExpand
    }
})
export default class vxeGridCell extends BaseVue {
    @Prop({ default: "view" }) gridType!: String; //表格类型('view'只读，'edit'行内编辑)
    @Prop({ default: () => ([]) }) ColConfig!: Array<any>; //列配置参数
    @Prop({ default: false }) isDragChange!: Boolean; //	是否通过拖拽改变父子级关系
    selectRow = true;
    showUpFileModal = false
    showEditorModal = false
    nowUpFileToken = ""
    nowUpFileotherParam: any = {}
    activeUpFileType = "uploadFiles"    //用来标识当前附件上传列类型
    nowEditorToken = ""
    nowEditorParam = {}
    regionAllData: any = []
    showJSONEditModal = false
    nowJSONEditParam: any = {}
    jsonEditOpenRow = {}
    async mounted() {

    }
    formatDate(value, format) {
        console.log(XEUtils.toDateString(value, format))
        console.log(value, format, '???')
        return XEUtils.toDateString(value, format)
    }
    //日期编辑格式化
    DatePickerEdit(row, key, value, format) {
        let valueNew = XEUtils.toDateString(value, format)
        this.$emit("dateChange",row, valueNew)
        row[key] = valueNew
    }
    /**
     * @description:  格式化列中下拉列表的文本值
     * @param {*} value
     * @param {*} list
     * @param {*} valueProp
     * @param {*} labelField
     * @return {*}
     */
    getSelectLabel(value, list, valueProp = 'value', labelField = 'text') {
        const item = XEUtils.find(list, item => item[valueProp] === value)
        if (typeof (value) == "number") {
            return item ? item[labelField] : null
        }
        if (typeof (value) == "string") {
            value = value.split(",")
        }
        if (value == undefined || value.length <= 1) {
            return item ? item[labelField] : null
        } else {
            let selecteds = this.Baselinq.from(list).where(item => value.indexOf(item[valueProp]) >= 0).toArray()
            let selectNames = this.Baselinq.from(selecteds).select((item) => item[labelField]).toArray();
            return selectNames.toString()
        }
        // if(value.length>1){
        //   let selecteds = this.Baselinq.from(list).where(item => value.indexOf(item[valueProp])>=0).toArray()
        //   let selectNames = this.Baselinq.from(selecteds).select((item) => item[labelField]).toArray();
        //   return selectNames.toString()
        // }else{
        //   return item ? item[labelField] : null
        // }
        // value = value.toString()
        // const item = XEUtils.find(list, item => item[valueProp] === value)
        // return item ? item[labelField] : null
    }
    //监听编辑框
    inputEdit(scope, item) {
        this.$emit("input-edit", scope, item)
    }
    upFileClick(token, param, row) {
        this.activeUpFileType = param.colType
        if (param.readonly) {
            param.otherParam.isShow = false
        }
        if (this.isNull(token)) {
            if (param.otherParam.isShow == false) {
                this.warning("暂无附件")
            } else {
                this.confirm("当前附件Token未设置，点击确认将为您自动设置，最后要记得执行表格上方'保存'操作哦！", () => {
                    token = this.NewGuid()
                    row[param.key] = token
                    this.nowUpFileToken = token
                    this.nowUpFileotherParam = param.otherParam
                    this.showUpFileModal = true
                })
            }
        } else {
            this.nowUpFileToken = token
            this.nowUpFileotherParam = param.otherParam
            this.showUpFileModal = true
        }
    }

    editorClick(token, param, row) {
        if (this.isNull(token)) {
            if (param.readonly) {
                this.warning("暂无文本内容")
            } else {
                this.confirm("当前文本文件Token未设置，点击确认将为您自动设置，最后要记得执行表格上方'保存'操作哦！", () => {
                    token = this.NewGuid()
                    row[param.key] = token
                    this.nowEditorToken = token
                    this.nowEditorParam = param
                    this.showEditorModal = true
                })
            }
        } else {
            this.nowEditorToken = token
            this.nowEditorParam = param
            this.showEditorModal = true
        }
    }
    clearRadioRowEevnt(e) {
        this.$emit("clearRadioRow");
    }

    jsonEditClick(json, param, row) {
        this.jsonEditOpenRow = row
        if (this.isNull(json)) {
            if (param.readonly) {
                this.warning("暂无JSON配置内容")
            } else {
                this.showJSONEditModal = true
                this.nowJSONEditParam = param
            }
        } else {
            this.showJSONEditModal = true
            this.$nextTick(() => {
                let jsonData: any = json
                try {
                    if (typeof (json) == "string") {
                        jsonData = JSON.parse(json)
                    }
                } catch (error) {
                    jsonData = json
                }
                this.ref('grid_json_edit').setJsonData(jsonData)
            })
            this.nowJSONEditParam = param
        }
    }

    okJSONEdit() {
        let jsonText = this.ref('grid_json_edit').getJsonData()
        this.jsonEditOpenRow[this.nowJSONEditParam.key] = jsonText
        this.showJSONEditModal = false
    }

    getRegionLabel(value) {
        if (this.isNull(value)) {
            value = []
        }
        if (typeof (value) == "number") {
            value = [value.toString()]
        }
        if (typeof (value) != "object") {
            value = value.split(",")
        }
        let regionName = ""
        value.forEach((item, i) => {
            let info: any = this.Baselinq.from(this.regionAllData).firstOrDefault(item2 => item2["Id"] == item)
            if (info) {
                regionName += (i > 0 ? "/" : "") + info.DistrcctName
            }
        });
        return regionName
    }
    SwitchChange(status, item, row) {
        item.onChange(status.value, row)
        // this.$emit("SwitchChange",status)
    }


    dragOldRowData: any = {}    //被拖动行数据
    dragNewRowData: any = {}    //拖动至行数据
    // 拖动开始
    dragstart(item, row) {
        this.dragOldRowData = row
    }
    // 记录移动过程中信息
    dragenter(item, row) {
        this.dragNewRowData = row
    }
    // 拖动结束
    dragend(item, row) {
        if (this.dragOldRowData.id == this.dragNewRowData.id || this.dragOldRowData.pid == this.dragNewRowData.id) {
            return
        }
        this.$emit("dragChanged", this.dragOldRowData, this.dragNewRowData)
        // this.$emit("delTreeListInfoById",this.dragOldRowData.id);
        // this.dragNewRowData.children.push(this.dragOldRowData)
        // setTimeout(() => {
        //   this.$emit("setTreeExpand",this.dragNewRowData,true);      
        // }, 100); 
    }
    roclick(item) {
        this.$emit("roclick", item)
    }

    mobileNoTxt(value) {
        return this.commonReg.mobileNo(value) ? value.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2") : "****"
    }
    idCardNoTxt(value) {
        return this.commonReg.idCardNo(value) ? value.replace(/(.{6}).*(.{4})/, "$1********$2") : "****"
    }

}

